import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface ConfirmDialogProps {
  show: boolean;
  title: string;
  message: string;
  confirmText: string;
  type?: 'primary' | 'danger' | 'secondary' | 'success' | 'warning' | 'info' | 'light' | 'dark';
  isConfirming?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  show,
  title,
  message,
  confirmText,
  type = 'primary',
  isConfirming = false,
  onConfirm,
  onCancel,
}) => {
  useTheme();

  if (!show) {
    return null;
  }

  return (
    <div
      className={`modal fade ${show ? 'show d-block' : ''}`}
      tabIndex={-1}
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content"
          style={{
            borderRadius: 'var(--radius-lg)', /* Smaller overall border radius */
            border: '1px solid var(--border-color)', /* Add a subtle border to the modal content */
            boxShadow: 'var(--shadow-md)', /* Lighter shadow */
            backgroundColor: 'var(--bg-color)',
            color: 'var(--text-primary)',
          }}
        >
          <div
            className="modal-header"
            style={{
              background: 'var(--surface-color)', /* Simpler background */
              color: 'var(--text-primary)', /* Adjust text color for contrast */
              borderBottom: '1px solid var(--border-color)', /* Add a subtle border */
              borderRadius: 'var(--radius-lg) var(--radius-lg) 0 0', /* Smaller top border radius */
            }}
          >
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close" /* Remove btn-close-white for theme consistency */
              aria-label="Close"
              onClick={onCancel}
            ></button>
          </div>
          <div className="modal-body">
            <p>{message}</p>
          </div>
          <div
            className="modal-footer"
            style={{
              borderTop: '1px solid var(--border-color)',
              backgroundColor: 'var(--surface-color)',
              borderRadius: '0 0 var(--radius-lg) var(--radius-lg)', /* Smaller bottom border radius */
            }}
          >
            <button type="button" className="btn btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button type="button" className={`btn btn-${type}`} onClick={onConfirm} disabled={isConfirming}>
              {isConfirming ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  {confirmText}
                </>
              ) : (
                confirmText
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;